import { render } from "./CookiesNormalInput.vue?vue&type=template&id=3bd43614&scoped=true&ts=true"
import script from "./CookiesNormalInput.vue?vue&type=script&lang=ts"
export * from "./CookiesNormalInput.vue?vue&type=script&lang=ts"

import "./CookiesNormalInput.vue?vue&type=style&index=0&id=3bd43614&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd43614"]])

export default __exports__